import React from 'react';
import { Application } from '../../../models';
import { SchoolIcon } from '../../icons';
import ProgramForm from './ProgramForm';

interface FifthStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function FifthStep({
  application = null,
  isReadOnly = false,
}: FifthStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#E5CFFF] border border-[#CEA5FF] flex">
        <SchoolIcon className="h-12 w-12 m-auto text-purple" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">
          Details of Programme
        </h2>
      </div>
      <div className="mt-8 flex flex-col">
        <ProgramForm
          application={application}
          program={application?.program}
          isReadOnly={isReadOnly}
        />
      </div>
    </div>
  );
}
